import { render, staticRenderFns } from "./VacationHistoricalCreate.vue?vue&type=template&id=26766fd2&scoped=true"
import script from "./VacationHistoricalCreate.vue?vue&type=script&lang=js"
export * from "./VacationHistoricalCreate.vue?vue&type=script&lang=js"
import style0 from "./VacationHistoricalCreate.vue?vue&type=style&index=0&id=26766fd2&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26766fd2",
  null
  
)

export default component.exports